import otel, { type Meter } from '@opentelemetry/api'
import type { InstrumentationModuleDefinition } from '@opentelemetry/instrumentation'
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

import { APP_NAME } from '../../config/costants'

export class WebVitalsInstrumentation {
  private myMeter: Meter

  private static mapping = {
    cls: onCLS,
    fcp: onFCP,
    inp: onINP,
    lcp: onLCP,
    ttfb: onTTFB,
  }

  /**
   * The function maps web vitals indicators to their corresponding executors and records the metric
   * values in a histogram.
   */
  public map(): void | InstrumentationModuleDefinition | InstrumentationModuleDefinition[] {
    Object.entries(WebVitalsInstrumentation.mapping).forEach(([indicator, executor]) => {
      executor((metric) => {
        const histogram = this.myMeter.createHistogram(indicator)
        histogram.record(metric.value, { name: metric.name })
      })
    })
  }

  constructor() {
    this.myMeter = otel.metrics.getMeter(APP_NAME)
  }
}
